@for (canister of currentCanisters(); track canister.surveyID; let i = $index) {
<div id="ecorr-canister-container">
    @if (canister.type === 'Image') {
    <div (click)="canisterClick(canister.surveyID)" (keyup.enter)="canisterClick(canister.surveyID)">
          <!-- Clickable image -->
        @if (canister.attachments[0]?.link) {
        <a href="{{ canister.attachments[0]?.link }}" target="_blank" tabindex="0">
            <img class="ecorr-canister-image" src="data:image/jpeg;base64,{{ canister.attachments[0]?.imageData }}" alt="{{ canister.articleID }}" />
        </a>
        }

          <!-- Unclickable image -->
        @if (!canister.attachments[0]?.link) {
        <img class="ecorr-canister-image" src="data:image/jpeg;base64,{{ canister.attachments[0]?.imageData }}" alt="{{ canister.articleID }}" />
        }
    </div>
}
</div>
}